import { FiscalRegime } from "@core/models/fiscal-regime.model";
import { FundWithRelated } from "@core/models/fund-with-related.model";
import { Product } from "@core/models/product.model";
import { ProductKind } from "@core/models/product-kind.model";
import { ProductsInfo } from "@core/models/products-info.model";
import { Utilities } from "@core/utils/utils";
import { TPagination } from "@custom-types/sorting";
import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromProduct from "./product.reducers";

export const SELECT_PRODUCT_STATE =
  createFeatureSelector<fromProduct.ProductState>(
    fromProduct.PRODUCT_FEATURE_KEY
  );

export const SELECT_PRODUCT_LIST = createSelector(
  SELECT_PRODUCT_STATE,
  (state: fromProduct.ProductState): Array<Product> => state.products
);

export const SELECT_PRODUCT_LOADING_STATUS = createSelector(
  SELECT_PRODUCT_STATE,
  (state: fromProduct.ProductState): boolean => state.loading
);

export const SELECT_FUND_LIST = createSelector(
  SELECT_PRODUCT_STATE,
  (state: fromProduct.ProductState): Array<FundWithRelated> => state.funds
);

export const SELECT_FISCAL_REGIME_LIST = createSelector(
  SELECT_PRODUCT_STATE,
  (state: fromProduct.ProductState): Array<FiscalRegime> => state.fiscalRegime
);

export const SELECT_PRODUCTS_INFO = createSelector(
  SELECT_PRODUCT_STATE,
  (state: fromProduct.ProductState): ProductsInfo => state.productsInfo
);

export const SELECT_PRODUCT_KIND = createSelector(
  SELECT_PRODUCT_STATE,
  (state: fromProduct.ProductState): Array<ProductKind> => state.productKind
);

export const SELECT_NON_DEVIATED_COSTS_COUNT = createSelector(
  SELECT_PRODUCT_STATE,
  (state: fromProduct.ProductState): number => state.nonDeviatedCostsCount
);

export const SELECT_PRODUCTS_LENGTH = createSelector(
  SELECT_PRODUCT_STATE,
  (state: fromProduct.ProductState): number =>
    Utilities.getPaginationTotalRecords(state.pagination)
);

export const SELECT_PRODUCTS_PAGINATION = createSelector(
  SELECT_PRODUCT_STATE,
  (state: fromProduct.ProductState): Partial<TPagination> | undefined =>
    state.pagination
);
